import React from 'react';
import {
  Menu, Icon, Row, Col, Dropdown, Input, Spin
  , LocaleProvider, message
} from 'antd';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import Page from './Page';
import cloudImg from '../../style/img/cloud.png';
import storeImg from '../../style/img/store.png';
import logo from '../../style/img/logo.png';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import util from '../../util/index';
import MobileMode from '../util/Mobilemode';

const { isWeaver, openEcode } = util;
const isOpen = openEcode();
const store = [
  'initStore',
  'listStore',
  'homeStore',
  'themeListStore',
  'modeListStore',
  'caseListStore',
  'mainStore',
  'workflowStore',
  'ecodeWfStore',
]

@inject(...store)
@observer
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuStyle: {
        borderRadius: 0, marginLeft: -20, textAlign: 'center'
      },
      moduleVisible: false,
      menuVisible: false,
      menuModuleStyle: {
        borderRadius: 0, marginLeft: -20, marginTop: -5, width: 150,
      },
      searchValue: ''
    }
  }

  componentDidMount() {
    window.isIE8 = window.navigator.appVersion.indexOf("MSIE 8.0") >= 0;
    window.isIE9 = window.navigator.appVersion.indexOf("MSIE 9.0") >= 0;
    const { homeStore, homeStore: { initTypes }, location: { search: s, query: q } } = this.props;
    const types = toJS(initTypes);
    if (s && q.id) {
      let name = types[q.id] ? types[q.id] : "";
      homeStore.setType(q.id, name);
    }
  }

  componentDidUpdate() {
    const { location, homeStore: { setMobxState, initTypes, type } } = this.props;
    const id = location.query.id;
    if (location.pathname === 'app/search' && toJS(type).id !== id) {
      setMobxState({ type: {id, name: initTypes[id] }});
    }
  }

  onMenuClick = (id, name, go = true) => {
    const { location, 
      location: { query }, 
      homeStore,
      homeStore: { routing },
      listStore: { setSearchValue },
      caseListStore: { clearSearchValue }
    } = this.props;
    const pathname = location.pathname;
    homeStore.setType(id, name);
    clearSearchValue();
    setSearchValue('');
    if(id === 'workflowStyle' || id === 'workflowChart') {
      routing.push({
        pathname: '/app/workflow',
        query: {
          ...query,
          id: 'workflow',
          type: id,
        }
      })
      this.setState({ moduleVisible: false });
      return;
    }
    if (!go) return;
    if (pathname !== '') {
      let path = pathname;
      if (id === 'all') {
        if(path === 'app/search') {
          this.allAppCallApis();
        } else {
          path = '/app';
        }
      } else {
        path = '/app';
      }
      if (pathname === 'projectapp') path = '/app/project';
      routing.push({
        pathname: path,
        query: {
          ...query,
          id: id,
        }
      });
    }
    this.setState({ moduleVisible: false });
  }
  callApis = () => {
    const {
      location,
      listStore: {
        callAppData, callScreenData, setCurrent,
        params: { searchValue },
      },
      themeListStore: {
        getThemeList, params, setState, getThemeE8List, initPage,
      },
      modeListStore: {
        getModeList, getMould, searchType,
      }
    } = this.props;
    const id = searchType;
    if (id === 'workflow') {
      setCurrent(1);
      callScreenData(id, location.query);
      callAppData(id);
    } else if (id === 'theme') {
      initPage();
      getThemeList({ title: searchValue });
      getThemeE8List({ searchValue });
    } else {
      getModeList({ searchValue, current: 1, module: getMould(id) });
    }
  }
  allAppCallApis = () => {
    const {
      listStore: { params: { searchValue } },
      themeListStore: { clear },
      homeStore: { globalSearchList, clearAppHot, initAllDatas, getAllData },
      mainStore: { init, clear: clearMain },
      caseListStore: { clear: clearCase,  },
      ecodeWfStore: { clear: clearWf },
    } = this.props;
    clearAppHot();
    init();
    clearMain();
    initAllDatas();
    clear();
    clearCase();
    clearWf();
    searchValue == "" ? getAllData() : globalSearchList({title: searchValue});
  }
  getOtherMenu = () => {
    const { location: { query } } = this.props;
    return [
      {
        key: 'collect', name: '我的收藏', icon: 'icon-Cloud-Collection',
        onClick: () => {
          window.open(`${window.server}/manager#/app/collect?id=${query.id || 'workflow'}`, '_blank');
        }
      },
      {
        key: 'order', name: '我的订单', icon: 'icon-Cloud-Order',
        onClick: () => {
          window.open(`${window.server}/manager#/app/order?id=${query.id ? 'app' : 'workflow'}`, '_blank');
        }
      },
    ]
  }
  getCaseParams = () => {
    const { caseListStore: { searchFormValue } } = this.props;
    let _searchFormValue = {...toJS(searchFormValue)};
    Object.keys(_searchFormValue).map(
      key => {
        _searchFormValue[key] || delete _searchFormValue[key]
      }
    )
    return _searchFormValue;
  }
  onPressEnter = (e) => {
    const {
      homeStore: { routing, type, setType },
      listStore: {
        params: { searchValue },
        setMobxState: listSetMobxState,
        setSearchValue,
      },
      caseListStore: { getCaseList, searchFormValue: _searchFormValue, setState: setCaseState, initPage: initCasePage },
      themeListStore: { getThemeList, initPage, getThemeE8List },
      workflowStore: { getCaseList: getWorkflowList, setState: setWorkflowState, searchFormValue: searchFormValue_w },
      location: { pathname, query },
    } = this.props;
    const value = e.target.value.trim();
    // setType(type.id, type.name);
    listSetMobxState({searchValueInfo: value});
    setSearchValue(value);
    if(pathname === 'app/workflow' || pathname.startsWith('app/workflowDetail')) {
      setWorkflowState({
        params: {
          pageNum: 1,
          pageSize: 12,
        },
        searchFormValue: {
          ...searchFormValue_w,
          title: value,
        }
      })
      if(pathname.startsWith('app/workflowDetail')) {
        routing.push('/app/workflow');
        return;
      }
      getWorkflowList();
      return;
    }
    
    if(type.id === 'mode' || type.id === 'docViewTemplate' || type.id === 'case' || type.id === 'app' || type.id === 'workflowStyle' || type.id === 'workflowChart') {
      let searchFormValue = {
        ..._searchFormValue, title:searchValue
      }
      if(type.id === 'mode' || type.id === 'docViewTemplate') searchFormValue.demotype = type.id;
      initCasePage();
      setCaseState({searchFormValue});
      getCaseList({
        ...this.getCaseParams(),
      });
      return;
    }
    if(type.id === 'theme') {
      initPage();
      getThemeList({ title: searchValue });
      getThemeE8List({ searchValue });
      return;
    }
    if(type.id === 'workflow') {
      routing.push({
        pathname: '/app/list',
        query: {
          id: type.id,
        }
      });
      return;
    }
    if(type.id === 'all'){
      listSetMobxState({searchValueInfo: value});
      this.allAppCallApis();
    }
    // this.callApis();
    this.setState({searchValue: value})
  }

  bbsSso = () => {
    const { initStore: { getSso } } = this.props;
    this.setState({ moduleVisible: false })
    getSso().then((data) => data.data ? window.open(`http://test.e-cloudstore.com.cn/bbs/#/home?userKey=${data.data}`) : window.open(`http://test.e-cloudstore.com.cn/bbs/#/home`));
  }
  
  getMenuUser = (isLogin) => {
    const { menuModuleStyle } = this.state;
    const { initStore, location: { query } } = this.props;
    const otherMenu = this.getOtherMenu();
    const isweaver = isWeaver();
    const menuUser = (
      <Menu style={menuModuleStyle}>
        {
          otherMenu && isweaver &&otherMenu.map(menu => (
            <Menu.Item key={menu.key}>
              <div className="menu-module" onClick={() => menu.onClick && menu.onClick()}>
                <span className={`${menu.icon} menu-module-icon`} />
                <span className="menu-module-title">{menu.name}</span>
              </div>
            </Menu.Item>
          ))
        }
        {
          isweaver && (
            <Menu.Item>
              <div className="menu-module" onClick={() => isLogin ? window.open(`${window.server}/manager#/app/order?id=${query.id}`) : message.info('对不起，此功能暂无权限！请登录后使用！')}>
                <Icon type="appstore" className="menu-module-icon" />
                <span className="menu-module-title">进入后台</span>
              </div>
            </Menu.Item>
          )
        }
        <Menu.Item>
          <div className="menu-module" onClick={() => {
            localStorage.removeItem('me');
            initStore.me = {};
          }}>
            <Icon type="poweroff" className="menu-module-icon" />
            <span className="menu-module-title">退出</span>
          </div>
        </Menu.Item>
      </Menu>
    );
    return menuUser;
  }
  render() {
    const { menuStyle, moduleVisible, menuVisible } = this.state;
    const { homeStore, location, initStore, listStore, themeListStore, location: { query } } = this.props;
    let { me, loadingPage } = initStore;

    //--------------------------------------登录-----------------------------------------------------//
    me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
    let isLogin = (me && null !== me.com && "" !== me.com && me.member && null !== me.member.m_name) ? true : false;
    //--------------------------------------------------------------------------------------------------//

    const { routing, type, setType } = homeStore;
    const { params, setSearchValue } = listStore;

    //-------------------------------------单点登录-----------------------------------------------------//
    let href = window.location.href;
    let key = href.indexOf('key=') > 0 ? href.match(/key\=[^\&^\#^\/^\:]+/)[0].split('=')[1] : '';
    //--------------------------------------------------------------------------------------------------//
    const menu = (
      <Menu style={menuStyle}>
        <Menu.Item><a onClick={() => this.onMenuClick('all', '全部应用')}>全部应用</a></Menu.Item>
        {/* <Menu.Item><a onClick={() => this.onMenuClick('workflow', '流程表单')}>流程表单</a></Menu.Item> */}
        <Menu.Item><a onClick={() => this.onMenuClick('workflowChart', '流程表单')}>流程表单</a></Menu.Item>
        <Menu.Item>
          <a onClick={() => {
            this.onMenuClick('theme', '门户主题');
            // themeListStore.themeList.length === 0 &&
            //   themeListStore.getThemeList({ current: 1, pageSize: 24 });
          }}>门户主题</a>
        </Menu.Item>
        <Menu.Item><a onClick={() => this.onMenuClick('case', '开发案例')}>开发案例</a></Menu.Item>
        <Menu.Item key="app"><a onClick={() => this.onMenuClick('app', '开发应用')}>开发应用</a></Menu.Item>
        <Menu.Item key="old"><a onClick={() => window.location.href = "/old"}>E8 应用</a></Menu.Item>
        <Menu.Item><a><MobileMode onClick={() => this.setState({ moduleVisible: false })}>建模构建库</MobileMode></a></Menu.Item>
        <Menu.Item key="mode"><a onClick={() => this.onMenuClick('mode', 'E9建模模板')}>E9建模模板</a></Menu.Item>
        <Menu.Item key="docViewTemplate"><a onClick={() => this.onMenuClick('docViewTemplate', '文档显示模板')}>文档显示模板</a></Menu.Item>
        {
          query.bbsSso === "true" ?
            [<Menu.Item><a onClick={this.bbsSso}>云商店论坛</a></Menu.Item>] : null
        }
      </Menu>
    );
    const isEcodeDetailPage = window.location.hash.indexOf('ecode/detail') >= 0;
    return (
      <LocaleProvider locale={zhCN}>
        <Spin spinning={loadingPage} style={{ marginTop: 100 }} size="large">
          <div className='home'>
            {
              !key && (
                <div>
                  <Row className='home-header'>
                    <Col span={3} offset={2} className='home-cloudstore' onClick={() => {
                      routing.push("/");
                      homeStore.setType("all", "全部应用");
                    }}>
                      <div>
                        <img src={cloudImg} style={{ marginRight: 12.7 }} alt='' />
                        <img src={storeImg} alt='' />
                      </div>
                    </Col>
                    <Col span={4} style={{ position: 'relative' }}>
                      {
                        !isEcodeDetailPage && (
                          <div className='home-header-search'>
                          </div>
                        )
                      }
                      {
                        !isEcodeDetailPage && (
                          <div className='home-header-search-main'>
                            <Icon type="search" className='home-header-search-icon' />
                            <Input className='home-header-search-content'
                              placeholder='请输入搜索内容'
                              value={toJS(params).searchValue}
                              onPressEnter={this.onPressEnter}
                              onChange={(e) => setSearchValue(e.target.value)}
                            />
                          </div>
                        )
                      }
                    </Col>
                    <Col span={13} className='home-header-navigation'>
                      {
                        !isEcodeDetailPage && (
                          <Dropdown overlay={menu} getPopupContainer={() => this.modulelayout} trigger={['click']} visible={moduleVisible}
                            onVisibleChange={(vis) => this.setState({ moduleVisible: vis })}>
                            <a className='ant-dropdown-link' ref={el => this.modulelayout = el}>
                              {type.name}<Icon type={moduleVisible ? "up" : "down"} />
                            </a>
                          </Dropdown>
                        )
                      }
                      { !isEcodeDetailPage ? isLogin ? (
                        <Dropdown overlay={this.getMenuUser(isLogin)} getPopupContainer={() => this.userLayout} trigger={['click']} placement="bottomRight" visible={menuVisible}
                          onVisibleChange={(vis) => this.setState({ menuVisible: vis })}>
                          <span className={`login-con ant-dropdown-link${menuVisible ? '-active' : ''}`} ref={el => this.userLayout = el}>
                            <Icon type="user" />
                            <a className='login'>{me && me.member && me.member.m_name}</a>
                            <Icon type={menuVisible ? "up" : "down"} />
                          </span>
                        </Dropdown>
                      ) : (
                          <span className="login-con">
                            <a className='login'
                              onClick={() => {
                                routing.push('/login');
                              }}>登录</a>
                            {/*<span className='login2'>|</span>*/}
                            {/*<a className='login'*/}
                            {/*onClick={() => {*/}
                            {/*routing.push('/register');*/}
                            {/*}}*/}
                            {/*>注册</a>*/}
                          </span>
                        ) : null}
                    </Col>
                  </Row>
                  {!this.props.children ? (<Page type={homeStore.type} location={location} />) : this.props.children}
                  <div className='home-footter'>
                    <Row>
                      <Col span={6} offset={5}>
                        <div className='home-footter-content'>
                          <img src={logo} alt='' />
                        </div>
                        <div className='home-footter-content'>
                          <Icon type="environment-o" className='home-footer-icon' />
                          <span className='home-footer-text'>上海市闵行区联航路1188号33号楼</span>
                        </div>
                        <div className='home-footter-content'>
                          <Icon type="mail" className='home-footer-icon' />
                          <span className='home-footer-text'>sales@weaver.com.cn</span>
                        </div>
                        <div className='home-footter-content'>
                          <Icon type="phone" className='home-footer-icon' />
                          <span className='home-footer-text'>021-68869298</span>
                        </div>
                      </Col>
                      <Col span={4}>
                        <div className='home-footter-content'>
                          <span className='home-footter-content-main'>关于云商店</span>
                        </div>
                        <div className='home-footter-content'>
                          <a href='https://www.e-cloudstore.com/#/?_k=s73jnm'>功能价值</a>
                        </div>
                        <div className='home-footter-content'>
                          <a href='/' target="_blank">价格体系</a>
                        </div>
                        <div className='home-footter-content'>
                          <a href='/' target="_blank">我们的服务</a>
                        </div>
                      </Col>
                      <Col span={4}>
                        <div className='home-footter-content'>
                          <span className='home-footter-content-main'>联系我们</span>
                        </div>
                        <div className='home-footter-content'>
                          <a href='' target="_blank">公司简介</a>
                        </div>
                        <div className='home-footter-content'>
                          <a href='/' target="_blank">产品特性</a>
                        </div>
                        <div className='home-footter-content'>
                          <a href='/' target="_blank">注册云商店</a>
                        </div>
                      </Col>
                      <Col span={5}>
                        <div className='home-footter-content'>
                          <span className='home-footter-content-main'>关于泛微</span>
                        </div>
                        <div className='home-footter-content'>
                          <a href='http://www.weaver.com.cn/'>泛微官网</a>
                        </div>
                        <div className='home-footter-content'>
                          <a href='/' target="_blank">产品方案</a>
                        </div>
                        <div className='home-footter-content'>
                          <a href='/' target="_blank">客户案例</a>
                        </div>
                        <div className='home-footter-content'>
                          <a href='/' target="_blank">服务中心</a>
                        </div>
                      </Col>
                    </Row>
                    <div className='copy-right'>
                      <p><a target="_blank" href="http://www.weaver.com.cn">版权所有：上海泛微网络科技股份有限公司</a></p>
                      <p>Copyright © 2001-2021 Weaver Network All Rights Reserved.<a target="_blank" href="https://beian.miit.gov.cn">沪ICP备05040488号-11</a></p>
                    </div>
                  </div>
                </div>
              )
            }
          </div>
        </Spin>
      </LocaleProvider>
    )
  }
}

export default App


//---------------------------------------顶部menu---------------------------------------------
// const menu = (
//   <Menu style={menuStyle}>
//     {/*<Menu.Item>*/}
//     {/*<a onClick={() => {*/}
//     {/*homeStore.setType("all", "全部应用");*/}
//     {/*if (pathname !== '') {*/}
//     {/*let path = '/' + pathname;*/}
//     {/*if (pathname === 'projectapp') path = '/app/project';*/}
//     {/*routing.push({*/}
//     {/*pathname: path,*/}
//     {/*query: {*/}
//     {/*id: 'all',*/}
//     {/*// application: 'all',*/}
//     {/*// radioType: '0',*/}
//     {/*// radioItem: '0',*/}
//     {/*// project: location.query.project || '0',*/}
//     {/*// scheme: location.query.scheme || '0',*/}
//     {/*// list: location.query.list || '0',*/}
//     {/*}*/}
//     {/*});*/}
//     {/*}*/}
//     {/*}}>全部应用</a>*/}
//     {/*</Menu.Item>*/}
//     <Menu.Item>
//       <a onClick={() => {
//         homeStore.setType("workflow", "流程表单");
//         if (pathname !== '') {
//           let path = '/' + pathname;
//           if (pathname === 'projectapp') path = '/app/project';
//           routing.push({
//             pathname: path,
//             query: {
//               id: 'workflow',
//               // application: 'workflow',
//               // radioType: '0',
//               // radioItem: '0',
//               // project: location.query.project || '0',
//               // scheme: location.query.scheme || '0',
//               // list: location.query.list || '0',
//             }
//           });
//         }
//       }}>流程表单</a>
//     </Menu.Item>
//     {/*<Menu.Item>*/}
//     {/*<a onClick={() => {*/}
//     {/*homeStore.setType("portal", "门户应用");*/}
//     {/*if (pathname !== '') {*/}
//     {/*let path = '/' + pathname;*/}
//     {/*if (pathname === 'projectapp') path = '/app/project';*/}
//     {/*routing.push({*/}
//     {/*pathname: path,*/}
//     {/*query: {*/}
//     {/*id: 'portal',*/}
//     {/*// application: 'portal',*/}
//     {/*// radioType: '0',*/}
//     {/*// radioItem: '0',*/}
//     {/*// project: location.query.project || '0',*/}
//     {/*// scheme: location.query.scheme || '0',*/}
//     {/*// list: location.query.list || '0',*/}
//     {/*}*/}
//     {/*});*/}
//     {/*}*/}
//     {/*}}>门户应用</a>*/}
//     {/*</Menu.Item>*/}
//   </Menu>
// );


// WEBPACK FOOTER //
// ./src/components/home/Home.js